import {
    SHOW_ALERT,
    REMOVE_ALERT,
    CLOSE_ALL_ALERTS
} from './actionTypes';

export const showAlert = (mensagem, tipo) => (
    {
        type: SHOW_ALERT,
        options: {
            mensagem,
            tipo,
            key: new Date().getTime() + Math.random()
        }
    }
);

export const removeAlert = key => (
    {
        type: REMOVE_ALERT,
        key,
    }
);

export const closeAllAlerts = () => (
    {
        type: CLOSE_ALL_ALERTS
    }
);
